import { render } from "./TestimonialsContent.vue?vue&type=template&id=115dbefa&scoped=true&ts=true"
import script from "./TestimonialsContent.vue?vue&type=script&lang=ts"
export * from "./TestimonialsContent.vue?vue&type=script&lang=ts"

import "./TestimonialsContent.vue?vue&type=style&index=0&id=115dbefa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115dbefa"]])

export default __exports__